import {
  SET_DEFAULT_ADD_MOVIE_TITLE,
} from '../../actions/action-types';


const initialState =  {
  defaultAddMovieTitle: null,
};

export default function appActionsReducer(state = initialState, action) {
  let newState = state;
  switch (action.type) {
    case SET_DEFAULT_ADD_MOVIE_TITLE:
      newState = Object.assign({}, state, { defaultAddMovieTitle: action.payload.defaultAddMovieTitle || null });
      break;
    default:
      break;
  }
  return newState;
}

